import React, { useEffect, useState } from 'react';

import { Loader, Select, SelectProps, useMantineTheme } from '@mantine/core';
import { SelectItem } from '@mantine/core/lib/Select/types';
import { useDebouncedValue } from '@mantine/hooks';
import useAutoCompleteClassType from 'hooks/classType/useAutoCompleteClassType';

interface IClassTypeSelectProps extends Omit<SelectProps, 'data'> {
  value: string | null;
  onChange: (value: string | null) => void;
}

const ClassTypeSelect = ({ value, onChange, ...selectProps }: IClassTypeSelectProps): JSX.Element => {
  const theme = useMantineTheme();
  const [options, setOptions] = useState<SelectItem[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm] = useDebouncedValue(searchTerm, 250);
  const { data, isSuccess, isLoading } = useAutoCompleteClassType({
    search: debouncedSearchTerm,
  });

  useEffect(() => {
    if (isSuccess && data) {
      const classTypes = data.data.results.map(classType => ({
        value: classType.kiloClassTypeId,
        label: classType.name,
      }));
      setOptions(classTypes);
    }
  }, [data, isSuccess]);

  return (
    <Select
      {...selectProps}
      data={options}
      searchable
      onSearchChange={setSearchTerm}
      nothingFound={isLoading ? 'Class types are loading' : 'Class types not found'}
      maxDropdownHeight={200}
      rightSection={isLoading ? <Loader size={theme.fontSizes.md} /> : undefined}
      clearable
      value={value}
      onChange={onChange}
      withinPortal
    />
  );
};

export default ClassTypeSelect;
